import actions from './actions';
import initialState from '../initialState';

export const modalsReducer = (state = initialState.modals, action) => {
    switch (action.type) {
        case actions.ESIGN_MODAL:
            return { ...state, esign: action.status };
        case actions.ESIGN_CAN_WITHDRAW:
            return { ...state, esignCanWithdraw: action.status };
        case actions.ESIGN_DATA:
            return { ...state, esignData: action.data };
        default:
            return state;
    }
};

export default modalsReducer;
